import React from "react";
import callicon from "../assets/ca.png";

const WhatsAppButton = () => {
  const phoneNumber = "7416116587";

  const handleClick = () => {
    // Using the 'tel:' protocol to make a call
    const url = `tel:${phoneNumber}`;
    window.location.href = url; // Opens the phone dialer
  };

  return (
    <div
      style={styles.button}
      onClick={handleClick}
      aria-label="Call us"
      className="animate-bounce"
    >
      <img
        src={callicon}
        alt="ANS SAFETY NETS ,safety nets in bengaluru,"
        tittle="ANS SAFETY NETS ,safety nets in bengaluru,safety nets, no 01 safety nets Balcony Safety Nets,
Children Safety Nets,
Industrial Safety Nets,
Pets Safety Nets,
Ducteria Nets,
Monkey Safety Nets,
Cricket Practice Nets,
Bird Spikes"
        style={styles.icon}
        loading="lazy"
      />
    </div>
  );
};

const styles = {
  button: {
    position: "fixed",
    bottom: "150px",
    right: "10px",
    cursor: "pointer",
    zIndex: "100000",
    borderRadius: "50%",
    backgroundColor: "#2c3639",
    color: "white",

    transition: "background-color 0.3s ease",
  },
  icon: {
    width: "50px",
    height: "50px",
  },
};

export default WhatsAppButton;
